<ng-container *ngIf="size === 'small'">
  <ng-container *ngIf="block">
    <div class="value" [ngClass]="classes" [ngStyle]="style">
      <ng-container *ngTemplateOutlet="smallContent"></ng-container>
    </div>
  </ng-container>

  <ng-container *ngIf="!block">
    <span class="value" [ngClass]="classes" [ngStyle]="style">
      <ng-container *ngTemplateOutlet="smallContent"></ng-container>
    </span>
  </ng-container>

  <ng-template #smallContent>
    <mat-icon *ngIf="icon" class="icon">{{ icon }}</mat-icon>
    <span [ngClass]="{ 'ml-half': icon && value }">{{ value }} {{ suffix }}</span>
    <span *ngIf="subtitle" [ngClass]="{ 'm-0': value === undefined }" class="subtitle">{{ subtitle }}</span>
  </ng-template>
</ng-container>

<div *ngIf="size === 'large'" class="large-container">
  <div fxLayout="column" class="value large" [ngClass]="classes" [ngStyle]="style">
    <div *ngIf="header" class="header-container mb-half">{{ header }}</div>
    <mat-icon *ngIf="icon" class="icon">{{ icon }}</mat-icon>
    <div class="value-container bold">{{ value }} {{ suffix }}</div>
    <span *ngIf="subtitle" [ngClass]="{ 'm-0': value === undefined }" class="subtitle">{{ subtitle }}</span>
  </div>
</div>
